<template>
  <div>
    <div
      class="btn-pricemodal-wrapper p-2"
      :class="currentStep > 1 ? 'show' : ''"
    >
      <b-button
        variant="danger"
        block
        class="p-2 d-flex justify-content-between shadow"
        @click="modalShow = !modalShow"
      >
        <span>合計</span>
        <span class="h5 font-weight-bold m-0">
          ¥{{ grandTotal.toLocaleString() }}-
        </span>
        <span>詳細を見る</span>
      </b-button>
    </div>

    <b-modal v-model="modalShow" id="modal-p-bottom" hide-header hide-footer>
      <header class="d-flex">
        <b-button variant="light" class="p-1" @click="modalShow = false">
          <svg
            viewBox="0 0 16 16"
            width="30"
            height="30"
            focusable="false"
            role="img"
            aria-label="x"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi-x b-icon bi"
          >
            <g>
              <path
                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
              ></path>
            </g>
          </svg>
        </b-button>
        <div class="pl-5 h3 mb-0 py-2">工事費の詳細</div>
      </header>
      <div
        class="p-3 scrollable"
        :style="
          'background-image: url(' +
          require('@/assets/images/bg-seigaha.png') +
          '); height: ' +
          scrollableHeight +
          'px;'
        "
      >
        <div class="price-card">
          <div class="price-card-header">
            <div
              class="text-center total-price bg-primary text-white h3 mb-0 py-2"
            >
              <small class="mr-1">総工事費&emsp;¥</small
              >{{ grandTotal.toLocaleString() }}
            </div>
          </div>
          <div class="price-card-body">
            <div class="price-card-section p-2">
              <dl class="form-row no-gutters mb-0">
                <dt class="col-3 text-primary">現在の<br />工事費</dt>
                <dd class="col-9 text-right h3 text-primary pt-1 mb-3">
                  <small class="mr-1">¥</small>{{ total.toLocaleString() }}
                </dd>
                <dt class="col-5">取外料金</dt>
                <dd class="col-7 text-right">
                  ¥{{ removal.toLocaleString() }}
                </dd>
                <dt class="col-5">リサイクル料金</dt>
                <dd class="col-7 text-right">
                  ¥{{ recycling.toLocaleString() }}
                </dd>
                <dt class="col-5">標準工事費</dt>
                <dd class="col-7 text-right">
                  ¥{{ standard.toLocaleString() }}
                </dd>
                <dt class="col-5">追加工事費</dt>
                <dd class="col-7 text-right">
                  ¥{{ additional.toLocaleString() }}
                </dd>
              </dl>
            </div>
            <div
              v-for="(detail, i) in priceDetail"
              :key="i"
              class="price-card-section p-2"
            >
              <dl class="form-row no-gutters mb-0">
                <dt class="col-3 text-primary">
                  {{ i + 1 }}台目の<br />工事費
                </dt>
                <dd class="col-6 text-right h3 text-primary pt-1">
                  <small class="mr-1">¥</small>{{ detail.total.toLocaleString() }}
                </dd>
                <dd class="col-3 text-right">
                  <b-button
                    variant="link"
                    size="sm"
                    class="text-danger text-decolation-none"
                    @click="showDeleteModal(i)"
                  >
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="22"
                      viewBox="0 0 448 512"
                      class=""
                    >
                      <path
                        fill="currentColor"
                        d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                        class=""
                      ></path>
                    </svg>
                  </b-button>
                </dd>
                <dt class="col-5">取外料金</dt>
                <dd class="col-7 text-right">
                  ¥{{ detail.removal.toLocaleString() }}
                </dd>
                <dt class="col-5">リサイクル料金</dt>
                <dd class="col-7 text-right">
                  ¥{{ detail.recycling.toLocaleString() }}
                </dd>
                <dt class="col-5">標準工事費</dt>
                <dd class="col-7 text-right">
                  ¥{{ detail.standard.toLocaleString() }}
                </dd>
                <dt class="col-5">追加工事費</dt>
                <dd class="col-7 text-right">
                  ¥{{ detail.additional.toLocaleString() }}
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <!-- /.price-card -->
        <div v-if="key1 !== ''">
          <p
            class="off-text text-left"
            style="
              color: red;
              margin-top: 15px;
              margin-bottom: 5px;
              font-weight: bold;
              font-size: 14px;
            "
          >
            {{ key1 }}
          </p>
          <div class="text-right">
            <small style="width: 100%">※沖縄店を除く</small>
          </div>
        </div>
        <ul class="font-weight-normal line-height-1_7 mt-5">
          <li>
            各種キャンペーン割引、工事付商品でご注文のお客様は本お申込完了後に改めてご案内致します。
          </li>
          <li>本シミュレーション結果は目安料金（消費税込み）です。</li>
          <li>最終確定の料金は、訪問時にご自宅環境を確認してご連絡します。</li>
          <li>メーカー設置基準に満たない設置は行なえません。</li>
          <li>
            環境、設置内容、機種によって、以下が発生する場合があります。
            <ol>
              <li>別途作業料の発生</li>
              <li>訪問日の調整（別日再訪問）</li>
              <li>設置のお断り</li>
            </ol>
          </li>
          <li>
            賃貸住宅や集合住宅の場合、穴あけやコンセント工事が必要な際に管理会社の許可が必要です。
          </li>
          <li>工事追加料金は、当日クレジットカード・キャッシュレス決済、または後日銀行振込（振込手数料はお客様ご負担）でのお支払いとなります。</li>
          <li>
            雨天など天候不良の場合は、日程を調整させて頂く場合があります。
          </li>
        </ul>
      </div>
      <footer class="px-3 py-2">
        <div class="text-right mb-2">
          合計
          <span class="h4 font-weight-bold"
            >¥{{ grandTotal.toLocaleString() }}-</span
          >
        </div>
        <!-- <b-button
          variant="warning"
          block
          class="btn-gd py-2"
          :disabled="!canSubmit"
          size="lg"
          @click="goToPage2()"
          >取付を依頼する</b-button
        > -->
      </footer>
    </b-modal>
    <DeleteModal ref="DeleteModal" />
    <PreGoToPage2Modal ref="PreGoToPage2Modal" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DeleteModal from "./modals/DeleteModal";
import PreGoToPage2Modal from "./modals/PreGoToPage2Modal";

export default {
  created() {
    this.read();
  },
  components: { DeleteModal, PreGoToPage2Modal },
  data() {
    return {
      modalShow: false,
      //データ読込
      key1: "",
    };
  },
  computed: {
    ...mapState({
      total() {
        return this.$store.getters.total;
      },
      removal() {
        return this.$store.getters.removal;
      },
      recycling() {
        return this.$store.getters.recycling;
      },
      standard() {
        return this.$store.getters.standard;
      },
      additional() {
        return this.$store.getters.additional;
      },
      priceDetail() {
        return this.$store.getters.priceDetail;
      },
      grandTotal() {
        return this.$store.getters.grandTotal;
      },
      currentStep() {
        return this.$store.getters.currentStep;
      },
      maxStep() {
        return this.$store.getters.maxStep;
      },
      isInServiceArea() {
        return this.$store.getters.isInServiceArea;
      },
    }),
    scrollableHeight() {
      return window.innerHeight - 137;
    },
    canSubmit() {
      if (!this.isInServiceArea) {
        return false;
      }
      if (this.priceDetail.length || this.maxStep == 12) {
        return true;
      }
      return false;
    },
  },
  methods: {
    goToPage2() {
      // 見積途中の場合警告出す
      if (this.maxStep < 12) {
        this.$refs.PreGoToPage2Modal.show();
      } else {
        // vuexに保存
        this.doPushPriceDetail();
        this.$router.push({ name: "page2" });
      }
    },
    ...mapActions({
      doPushPriceDetail: "doPushPriceDetail",
    }),
    showDeleteModal(index) {
      this.$refs.DeleteModal.show(index);
    },
    read() {
      const url = "functions/read.php";
      this.axios
        .get(url, null)
        .then((res) => {
          console.log(res.data);
          if (res.data == false || res.data == "" || res.data == "false") {
            console.log(res.data);
          } else {
            let data = JSON.parse(res.data);
            console.log(data.key1);
            console.log(this.key1);
            this.key1 = data.key1;
            console.log(this.key1);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss">
.btn-pricemodal-wrapper {
  position: fixed;
  z-index: 10;
  bottom: -50px;
  left: 0;
  width: 100vw;
  transition: bottom 0.6s;
  &.show {
    bottom: 0;
  }
}
#modal-p-bottom {
  .modal-dialog {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: 100% !important;
    margin: 0;
    transform: translateY(100%) !important;
    height: 100%;
    .modal-content {
      border-radius: 0;
      .modal-body {
        padding: 0;
        .scrollable {
          overflow: scroll;
        }
      }
    }
  }

  &.show {
    overflow: hidden;
    .modal-dialog {
      transform: translateY(0%) !important;
      min-height: 80px;
    }
  }
}
</style>
<style lang="scss" scoped>
.price-card-header {
  border-radius: 0.25rem 0.25rem 0 0;
  overflow: hidden;
}
.price-card-body {
  border: 2px solid #5385b0;
  border-top-width: 0;
  border-radius: 0 0 0.25rem 0.25rem;
  background-color: #fff;
}
.price-card-section + .price-card-section {
  border-top: 2px solid #5385b0;
}
</style>